import { createArchivedFilter } from '@ayocore/erp/crm/client/components/filters';
import type { PartnerRepository } from '@ayocore/erp/crm/server/repositories/PartnerRepository';

/**
 * Фильтр «Архив» для списка партнёров.
 * По умолчанию показываем активные; очистка (X) показывает всё.
 */
export const FilterByArchived = createArchivedFilter<PartnerRepository>({
  applyArchived: (repo, archived) => repo.filterByArchived(archived),
  width: 130,
  logLabel: 'Partner FilterByArchived',
});
